/** Platform admin on the user document (`GET /get/currentuser`), not workspace `users[].admin`. */
export const isPlatformAdmin = (user: unknown): boolean => {
	if (!user || typeof user !== "object") {
		return false;
	}
	return "role" in user && (user as { readonly role?: unknown }).role === "admin";
};
